import { createReducer } from '@reduxjs/toolkit';
import {
    SET_SUBMITTING_WORKWITHUS, UNSET_SUBMITTING_WORKWITHUS, SET_SUBMITTED_WORKWITHUS,
} from '../actions/WorkWithUsActions';

const initialState = {
    submitting: false,
    submitted: false,
};

const workWithUs = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_SUBMITTING_WORKWITHUS, (state) => {
            state.submitting = true;
        })
        .addCase(UNSET_SUBMITTING_WORKWITHUS, (state) => {
            state.submitting = false;
        })
        .addCase(SET_SUBMITTED_WORKWITHUS, (state) => {
            state.submitted = true;
        });
});

export default workWithUs;
